import { render } from 'preact'
import { Router } from '@/router'
import { loadConfig } from '../config'
import { initI18n } from './i18n/config'
import './styles.css'

// Load configuration and initialize i18n from server before starting the app
loadConfig()
  .then(() => initI18n())
  .then(() => {
    render(<Router />, document.getElementById('app')!)
  })
  .catch(error => {
    console.error('Failed to load configuration or initialize i18n:', error)
    // Render app anyway with fallback config
    render(<Router />, document.getElementById('app')!)
  })
